import type { TriggerJobResponseAction } from './triggerJob.action';
import type { UploadFileResponseAction } from './uploadFile.action';

export * from './triggerJob.action';
export * from './uploadFile.action';

export type FileIngestorAction = TriggerJobResponseAction | UploadFileResponseAction;
